module.exports = __webpack_public_path__ + "media/error.0e393983.wav";